
function SdOrderPointsCtrl(TranslationService, StoreService, ToastService, $uibModal) {
    var ctrl = this;

    ctrl.$onInit = function () {
        //ctrl.points = [];        
    }

    ctrl.$onChanges = function (newValues, oldValues) {
        console.log('sd-order-points.onChanges');
        if (newValues.order) {
            // && newValues.order.currentValue.Points
            if (newValues.order.currentValue) {
                ctrl.initOrder(newValues.order.currentValue);
            }
        }
    };

    ctrl.initOrder = function (order) {
        console.log('initOrder');
        if (!order.Points) {
            order.Points = [];
        }
        if (order.Points.length <= 0) {
            order.Points.push({
                PointID: ctrl.pointId,
                AddressID: '',
                AddressContainers: ''
            });
        }
    };

    ctrl.isEditingOrInserting = function () {
        return ctrl.order.isEditing || ctrl.order.isInserting;
    };

    ctrl.addPoint = function () {
        var point = {
            PointID: ctrl.pointId,
            AddressID: '',
            AddressContainers: ''
        };
        if (!ctrl.order.Points) {
            ctrl.order.Points = [];
        }
        ctrl.order.Points.push(point);
    };

    ctrl.removePoint = function (index) {
        console.log('remove ' + index);
        ctrl.order.Points.splice(index, 1);
    };

    //ctrl.selectItem = function (point, option) {
    //    console.log('selectItem',point, option);
    //    //ctrl.modelId = item.Key;
    //    //model = item.Value;
    //};

    ctrl.getPeso = function (point) {
        if (!ctrl.addresses) {
            return '';
        }
        var p = ctrl.addresses.find(function (a) {
            return a.AddressID == point.AddressID;
        });
        if (p) {
            return p.limite_peso;
        }
        else {
            return '';
        }
    };
}

SdOrderPointsCtrl.$inject = ['TranslationService', 'StoreService', 'ToastService', '$uibModal'];

seedWebApp.component('sdOrderPoints', {
    controller: SdOrderPointsCtrl,
    bindings: {
        loading: '<',
        order: '<',
        pointId: '<',
        disabled: '<',
        addresses: '<'
    },
    templateUrl: '/SPA/Orders/sd-order-points.html'
});
